import JobsthemeColorsData from "../../js/jobsthemeColorsData";
import CategoriesBtnColor from "../../js/categoriesBtnData";
import Icons from "../../assets/icon";
import { IoIosArrowRoundBack } from "react-icons/io";
import {
  Animatespin,
  MainHeading,
  JobsCom,
  HoverButton,
  InputField,
  Footer,
  Navbar,
  Experience,
  MultiplayCheckBoxSelection,
  Dropdown,
  CategoriesBtnCom,
} from "../../components";
import localimgpath from "../../js/localimgpath";
import Functions from "./index.function";
export default function JobListing() {
  const {
    jobslisting,
    handleJobClick,
    handleSevedJob,
    loadingJobId,
    jobTypes,
    allcategories,
    seteledcategories,
    handleButtonClick,
    typesByJobslisting,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    joblisloading,
    categoriesTypesJobId,
    setCategoriesTtypesNewsId,
    filterPopup,
    setFilterPopup,
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    errors,
    dropdowns,
    dropdownLoading,
    states,
    isLoadingStates,
    cities,
    citiesisLoading,
    handleDropdwonSelect,
    experiences,
    index,
    rangeRef,
    tooltipPos,
    handleInput,
    selectedExperience,
    isFreelance,
    toggleFreelance,
    onSubmit,
    resetFilters,
    setAllcategories,
    setSeteledcategories,
    typesisFetchingNextPage,
    select,
    typesHasNextPage,
    typesFetchNextPage,
    typeslisloading,
    jobDropdowns,
  } = Functions();
  return (
    <div className="bg-primary">
      <Navbar />
      <div className="lg:px-5 xl:px-10 sm:px-5 xs:px-3 m-auto xs:py-5">
        <MainHeading
          title={"Job Listing"}
          dis={" "}
          layout={"h-18 sm:h-20 lg:h-36"}
          navigate={"/"}
        />
        <div className="flex justify-center items-start xs:gap-x-1 sm:gap-x-3">
          <div className=" py-4">
            <CategoriesBtnCom
              onClick={() => {
                setFilterPopup(true);
              }}
              btnTitle={"Filter"}
              bgColor={"#2A2A2A"}
              btnIcon={Icons.joblistingFiltersIcons}
              CateclassName={
                "cursor-pointer xs:rounded-md sm:rounded-lg xs:px-4 xs:py-2 sm:py-3 xs:gap-x-1 sm:px-5 sm:gap-x-2 relative flex items-center justify-center overflow-hidden text-secondary transition-all shadow-md before:absolute before:h-0 before:w-0 before:rounded-full before:bg-orange-600 hover:shadow-orange-600 before:duration-500 before:ease-out hover:before:h-56 lg:hover:before:w-72 2xl:hover:before:w-80 3xl:hover:before:w-96 sm:hover:before:w-64"
              }
              fontClassname={"font-onestSemiBold"}
              iconlayout={"xs:w-4 sm:w-5 lg:w-5"}
              alt={"Filter"}
            />
          </div>
          <div className="overflow-x-auto dashboard-scrollbar-cat px-2 py-4">
            <div className="flex xs:gap-x-2 sm:gap-x-3 items-center justify-center mx-auto w-max">
              <div>
                <CategoriesBtnCom
                  onClick={() => {
                    setAllcategories(true);
                    setSeteledcategories(false);
                    setCategoriesTtypesNewsId(null);
                  }}
                  btnTitle={"All"}
                  bgColor={"#FA5738"}
                  btnIcon={Icons.directorChairIcon}
                  CateclassName={
                    "cursor-pointer xs:rounded-md sm:rounded-lg xs:px-4 xs:py-2 sm:py-3 xs:gap-x-1 sm:px-5 sm:gap-x-2 relative flex items-center justify-center overflow-hidden text-secondary transition-all shadow-md before:absolute before:h-0 before:w-0 before:rounded-full before:bg-orange-600 hover:shadow-orange-600 before:duration-500 before:ease-out hover:before:h-56 lg:hover:before:w-72 2xl:hover:before:w-80 3xl:hover:before:w-96 sm:hover:before:w-64"
                  }
                  fontClassname={"font-onestSemiBold"}
                  iconlayout={"xs:w-4 sm:w-5 lg:w-5"}
                  alt={"All"}
                />
              </div>
              <div className="grid grid-flow-col auto-cols-max gap-x-3 ">
                {jobTypes?.jobs?.map((value, index) => (
                  <CategoriesBtnCom
                    key={index}
                    onClick={() => handleButtonClick(value?.id)}
                    btnTitle={value?.job_type}
                    bgColor={
                      allcategories
                        ? CategoriesBtnColor[
                            (index + 1) % CategoriesBtnColor.length
                          ].bgColor
                        : categoriesTypesJobId === value?.id
                        ? CategoriesBtnColor[
                            (index + 1) % CategoriesBtnColor.length
                          ].activeBgColor
                        : CategoriesBtnColor[
                            (index + 1) % CategoriesBtnColor.length
                          ].bgColor
                    }
                    btnIcon={
                      value?.icon
                        ? `${localimgpath?.categoryIcons}/${value?.icon}`
                        : Icons.directorChairIcon
                    }
                    CateclassName={
                      "cursor-pointer xs:rounded-md sm:rounded-lg xs:px-4 xs:py-2 sm:py-3 xs:gap-x-1 sm:px-5 sm:gap-x-2 relative flex items-center justify-center overflow-hidden text-secondary transition-all shadow-md before:absolute before:h-0 before:w-0 before:rounded-full before:bg-orange-600 hover:shadow-orange-600 before:duration-500 before:ease-out hover:before:h-56 lg:hover:before:w-72 2xl:hover:before:w-80 3xl:hover:before:w-96 sm:hover:before:w-64"
                    }
                    fontClassname={"font-onestSemiBold"}
                    iconlayout={"xs:w-4 sm:w-5 lg:w-5"}
                    alt={value?.title}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
        {seteledcategories && (
          <>
            {!typeslisloading &&
            typesByJobslisting?.pages?.every((p) => p?.jobs?.length === 0) ? (
              <div className="text-white text-center pt-3">
                Job Data not found
              </div>
            ) : (
              <>
                <div className="lg:mt-8 lg:pt-14 xs:pt-5 xs:pb-5 sm:py-6 grid xs:grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 xs:gap-y-3 sm:gap-5 xl:gap-7 3xl:gap-12">
                  {typesByJobslisting?.pages?.map((value, index) =>
                    value?.jobs?.map((value, index) => (
                      <div key={index}>
                        <JobsCom
                          onClick={() => handleJobClick(value?.id)}
                          subtitle={value?.company?.name}
                          jobsTitle={value?.title}
                          jobsDis={value?.description?.split(".")[0] + "."}
                          timingbtnTitle={
                            value?.job_types?.job_type === null
                              ? "Full Time"
                              : value?.job_types?.job_type
                          }
                          salarybtnTitle={`${value?.salary_currency ?? ""}${
                            value?.salary_from
                          } - ${value?.salary_currency ?? ""}${
                            value?.salary_to
                          }`}
                          jobstheme={
                            JobsthemeColorsData[
                              index % JobsthemeColorsData?.length
                            ].jobstheme
                          }
                          btntheme={
                            JobsthemeColorsData[
                              index % JobsthemeColorsData?.length
                            ].btntheme
                          }
                          location={
                            value?.country?.country === null
                              ? "Australia"
                              : value?.country?.country
                          }
                          navigate={() => handleJobClick(value?.id)}
                          loadingapi={loadingJobId === value?.id}
                          hide_salary={value?.hide_salary}
                          isSaved={value?.is_job_saved}
                          savedJob={() =>
                            handleSevedJob(value?.id, value?.is_job_saved)
                          }
                        />
                      </div>
                    ))
                  )}
                </div>
              </>
            )}

            {typesisFetchingNextPage || typeslisloading ? (
              <div className="pt-4">
                <Animatespin />
              </div>
            ) : (
              typesHasNextPage && (
                <div className="flex justify-center items-center pt-20">
                  <HoverButton
                    onClick={() => typesFetchNextPage()}
                    extraClasses="group xs:w-56 xs:h-8 sm:w-60 sm:h-12 lg:w-64 bg-cover flex lg:h-12 items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md"
                    BtnTitle="Load More Job"
                    BtnTitleClasses="text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform group-hover:scale-110 group-hover:text-primary"
                  />
                </div>
              )
            )}
          </>
        )}
        {allcategories && (
          <>
            {
              // jobslisting?.jobs?.length < 1 ? (
              !joblisloading &&
              jobslisting?.pages?.every((p) => p?.jobs?.length === 0) ? (
                <div className="text-white text-center pt-3">
                  Job Data not found
                </div>
              ) : (
                <>
                  <div className="lg:mt-8 lg:pt-14 xs:pt-5 xs:pb-5 sm:py-6 grid xs:grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 xs:gap-y-3 sm:gap-5 xl:gap-7 3xl:gap-12">
                    {jobslisting?.pages?.map((value, index) =>
                      value?.jobs?.map((value, index) => (
                        <div key={index}>
                          <JobsCom
                            onClick={() => handleJobClick(value?.id)}
                            subtitle={value?.company?.name}
                            jobsTitle={value?.title}
                            jobsDis={value?.description?.split(".")[0] + "."}
                            timingbtnTitle={
                              value?.job_types?.job_type === null
                                ? "Full Time"
                                : value?.job_types?.job_type
                            }
                            salarybtnTitle={`${value?.salary_currency ?? ""}${
                              value?.salary_from
                            } - ${value?.salary_currency ?? ""}${
                              value?.salary_to
                            }`}
                            jobstheme={
                              JobsthemeColorsData[
                                index % JobsthemeColorsData?.length
                              ].jobstheme
                            }
                            btntheme={
                              JobsthemeColorsData[
                                index % JobsthemeColorsData?.length
                              ].btntheme
                            }
                            location={
                              value?.country?.country === null
                                ? "Australia"
                                : value?.country?.country
                            }
                            navigate={() => handleJobClick(value?.id)}
                            loadingapi={loadingJobId === value?.id}
                            hide_salary={value?.hide_salary}
                            isSaved={value?.is_job_saved}
                            savedJob={() =>
                              handleSevedJob(value?.id, value?.is_job_saved)
                            }
                          />
                        </div>
                      ))
                    )}
                  </div>
                  {isFetchingNextPage || joblisloading ? (
                    <div className="pt-4">
                      <Animatespin />
                    </div>
                  ) : (
                    hasNextPage && (
                      <div className="flex justify-center items-center pt-20">
                        <HoverButton
                          onClick={() => fetchNextPage()}
                          extraClasses="group xs:w-56 xs:h-8 sm:w-60 sm:h-12 lg:w-64 bg-cover flex lg:h-12 items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md"
                          BtnTitle="Load More Job"
                          BtnTitleClasses="text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform group-hover:scale-110 group-hover:text-primary"
                        />
                      </div>
                    )
                  )}
                </>
              )
            }
          </>
        )}
        <div
          className={`fixed top-0 right-0 z-50 w-full sm:w-9/12 lg:w-7/12 xl:w-1/3 bg-[#0F0F0F] xs:py-3 xs:px-4 sm:px-3 sm:py-4 lg:px-4 lg:py-5 h-screen transition-transform duration-300 ease-in-out ${
            filterPopup ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <form
            className="flex flex-col h-full w-full"
            onSubmit={handleSubmit(onSubmit)}
          >
            {/* Header */}
            <div className="w-full">
              <div
                className={`group flex cursor-pointer justify-center items-center xs:px-1.5 sm:px-3 w-fit lg:px-5 xs:py-[1.5px] sm:py-1 bg-[#2A2A2A] xs:rounded-md sm:rounded-lg transition-transform duration-300 transform hover:scale-105`}
                onClick={() => setFilterPopup(false)}
              >
                <IoIosArrowRoundBack className="text-secondary sm:text-2xl transition-colors duration-300 group-hover:text-orangeCrayola" />
                <p className="text-secondary font-onestRegular xs:text-xs sm:text-sm lg:text-sm transition-colors duration-300 group-hover:text-secondary">
                  Back
                </p>
              </div>
              <div className="text-center w-full xs:pt-4 xs:pb-5 sm:pt-7 sm:pb-7 lg:pb-10">
                <h2 className="text-secondary font-unboundedBold uppercase xs:text-xs sm:text-lg lg:text-xl xl:text-4xl">
                  Job Filter
                </h2>
              </div>
            </div>

            {/* Scrollable Form Section */}
            <div className="flex-1 overflow-y-auto dashboard-scrollbar  sm:pr-2 pr-1">
              <div className="flex flex-col justify-start items-center w-full gap-4">
                <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                  <div className="relative xs:w-full sm:w-1/2 lg:w-1/2">
                    <Dropdown
                      control={control}
                      label={"Country"}
                      options={dropdowns?.country}
                      valueName="country"
                      valueoption="country_id"
                      name={"countries"}
                      rightIcon={Icons.arrowIcon}
                      selectedValue={select.country}
                      handleSelect={(value) =>
                        handleDropdwonSelect("country", value)
                      }
                      errors={errors}
                      isRequired={true}
                      isLoading={dropdownLoading}
                    />
                  </div>
                  <div className="relative xs:w-full sm:w-1/2 lg:w-1/2">
                    <Dropdown
                      control={control}
                      label={"Province / State"}
                      options={states}
                      name={"states"}
                      valueName="state"
                      valueoption="state_id"
                      rightIcon={Icons.arrowIcon}
                      selectedValue={select.states}
                      handleSelect={(value) =>
                        handleDropdwonSelect("states", value)
                      }
                      errors={errors}
                      isRequired={true}
                      isLoading={isLoadingStates}
                    />
                  </div>
                </div>
                <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                  <div className="relative mt-[18px] w-full sm:w-11/12">
                    <Dropdown
                      control={control}
                      rightIcon={Icons.arrowIcon}
                      label={"City"}
                      options={cities}
                      selectedValue={select?.city}
                      handleSelect={(value) =>
                        handleDropdwonSelect("city", value)
                      }
                      valueName="city"
                      valueoption="city_id"
                      name={"city"}
                      errors={errors}
                      isRequired={true}
                      isLoading={citiesisLoading}
                    />
                  </div>
                  <div className="relative mt-[18px] w-full sm:w-11/12">
                    <Dropdown
                      control={control}
                      rightIcon={Icons.arrowIcon}
                      label={"Gender"}
                      options={dropdowns?.gender}
                      name={"gender"}
                      selectedValue={select.gender}
                      handleSelect={(value) =>
                        handleDropdwonSelect("gender", value)
                      }
                      valueName="gender"
                      valueoption="id"
                      isRequired={true}
                      isLoading={dropdownLoading}
                    />
                  </div>
                </div>
                <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                  <div className="relative mt-[18px] w-full sm:w-11/12">
                    <div className="sm:mb-2 lg:mb-2 flex justify-start items-center">
                      <label className="xs:text-sm sm:text-base font-onestRegular text-secondary">
                        Job Shift
                      </label>
                    </div>
                    <MultiplayCheckBoxSelection
                      control={control}
                      name="job_shift"
                      items={"job_shift"}
                      mapitems={jobDropdowns?.job_shift}
                      // register={register}
                      errors={errors}
                      isRequired={false}
                      // label="job_shift"
                    />
                  </div>
                  <div className="relative mt-[18px] w-full sm:w-11/12">
                    <Dropdown
                      control={control}
                      rightIcon={Icons.arrowIcon}
                      label={"Degree Level"}
                      options={jobDropdowns?.degree_level}
                      name={"degree_level"}
                      selectedValue={select?.degree_level}
                      handleSelect={(value) =>
                        handleDropdwonSelect("degree_level", value)
                      }
                      valueName="degree_level"
                      valueoption="degree_level_id"
                      errors={errors}
                      isRequired={true}
                      isLoading={dropdownLoading}
                    />
                  </div>
                </div>
                <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                  <div className="relative mt-[18px] w-full">
                    <div className="w-full text-white">
                      <label className="block xs:text-sm sm:text-base font-onestRegular text-secondary mb-1">
                        Experience{" "}
                        <span className="text-xs font-onestRegular">
                          (years)
                        </span>
                      </label>
                      <div className="relative w-full mt-4">
                        {/* Tooltip */}
                        {selectedExperience !== null && (
                          <div
                            // ref={tooltipRef}
                            className="absolute -top-7 transform -translate-x-1/2 text-white text-xs font-semibold px-2 py-1 rounded whitespace-nowrap bg-goldMetallic"
                            style={{ left: tooltipPos }}
                          >
                            {selectedExperience}
                            <div className="absolute left-1/2 top-full -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-goldMetallic" />
                          </div>
                        )}
                        {/* Slider */}
                        <input
                          ref={rangeRef}
                          type="range"
                          min="0"
                          max={experiences.length - 1}
                          value={index}
                          onChange={handleInput}
                          className="w-full h-2 bg-[#636363] rounded-lg appearance-none cursor-pointer
                                                                [&::-webkit-slider-thumb]:appearance-none
             [&::-webkit-slider-thumb]:w-4
             [&::-webkit-slider-thumb]:h-4
             [&::-webkit-slider-thumb]:rounded-full
             [&::-webkit-slider-thumb]:bg-yellow-400
             [&::-webkit-slider-thumb]:border-2
             [&::-webkit-slider-thumb]:border-white
             [&::-webkit-slider-thumb]:shadow-md
             [&::-moz-range-thumb]:appearance-none
             [&::-moz-range-thumb]:w-4
             [&::-moz-range-thumb]:h-4
             [&::-moz-range-thumb]:rounded-full
             [&::-moz-range-thumb]:bg-yellow-400
             [&::-moz-range-thumb]:border-2
             [&::-moz-range-thumb]:border-white
             [&::-moz-range-thumb]:shadow-md"
                          style={{
                            background: `linear-gradient(to right, #D9A239 0%, #D9A239 ${
                              (index / (experiences.length - 1)) * 100
                            }%, #636363 ${
                              (index / (experiences.length - 1)) * 100
                            }%, #636363 100%)`,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                  <div className="relative mt-[18px] w-full">
                    <Dropdown
                      control={control}
                      rightIcon={Icons.arrowIcon}
                      label={"Salary Period"}
                      options={jobDropdowns?.salary_period}
                      name={"salary_period"}
                      selectedValue={select?.salary_period}
                      handleSelect={(value) =>
                        handleDropdwonSelect("salary_period", value)
                      }
                      valueName="salary_period"
                      valueoption="salary_period_id"
                      errors={errors}
                      isRequired={true}
                      isLoading={dropdownLoading}
                    />
                  </div>
                </div>
                <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                  <div className="relative mt-[18px] w-full sm:w-11/12">
                    <InputField
                      control={control}
                      label="Salary From"
                      type="number"
                      name="salaryFrom"
                      {...register("salaryFrom", {
                        // required: 'Salary From is required',
                        validate: (value) => {
                          const to = getValues("salaryTo");
                          return (
                            !to ||
                            parseFloat(value) <= parseFloat(to) ||
                            "Salary From must be less than or equal to Salary To"
                          );
                        },
                      })}
                      // errors={errors}
                      onChange={(value) => setValue("salaryFrom", value)}
                    />
                  </div>
                  <div className="relative mt-[18px] w-full sm:w-11/12">
                    <InputField
                      control={control}
                      label="Salary To"
                      type="number"
                      name="salaryTo"
                      {...register("salaryTo", {
                        // required: 'Salary To is required',
                        validate: (value) => {
                          const from = getValues("salaryFrom");
                          return (
                            !from ||
                            parseFloat(value) >= parseFloat(from) ||
                            "Salary To must be greater than or equal to Salary From"
                          );
                        },
                      })}
                      // errors={errors}
                      onChange={(value) => setValue("salaryTo", value)}
                    />
                  </div>
                </div>
                <div className="flex justify-between items-center w-full py-3">
                  <div className=" flex justify-start items-center">
                    <label className="xs:text-sm sm:text-base font-onestRegular text-secondary">
                      Freelance
                    </label>
                  </div>
                  <div
                    onClick={toggleFreelance}
                    className={`w-16 h-8 xs:w-14 xs:h-6 sm:w-[60px] sm:h-7 rounded-full border-2 bg-primary border-goldMetallic relative cursor-pointer transition-all`}
                  >
                    <div
                      className={`w-6 h-6 xs:w-4 xs:h-4 sm:w-5 sm:h-5  text-white rounded-full absolute top-[2px] left-[2px] transition-transform duration-300 ${
                        isFreelance === 1
                          ? "transform translate-x-8 bg-goldMetallic"
                          : " bg-white"
                      }`}
                    ></div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer Buttons */}
            <div className="py-2 w-full">
              <div
                onClick={resetFilters}
                className="w-full py-2 flex text-secondary justify-end items-center"
              >
                <p className="cursor-pointer hover:underline hover:text-orangeCrayola transition duration-200">
                  Reset Filters
                </p>
              </div>
              <div className="xs:text-[8px] sm:text-xs lg:text-sm xl:text-base flex xs:pt-1 sm:pt-2 lg:pt-3 w-full justify-center">
                <div className="xs:gap-1 sm:gap-2 lg:gap-3 flex justify-center items-center w-full">
                  <button
                    className="bg-accepted xs:py-2 w-full flex justify-center xs:px-6 sm:px-8 sm:py-1 lg:px-10 lg:py-1 rounded-full cursor-pointer"
                    type="submit"
                    disabled={joblisloading}
                  >
                    {joblisloading ? (
                      <div className="flex justify-center items-center">
                        <div className="animate-spin rounded-full border-t-2 border-b-2 group-hover:border-primary border-secondary w-6 h-6"></div>
                      </div>
                    ) : (
                      <p className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base font-onestRegular text-secondary">
                        Apply
                      </p>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <Experience />
      <Footer />
    </div>
  );
}
